<template>
  <div class="userCenterList footerPosition">
    <div class="statement marBot10">
      <ul class="activeTabT">
        <li :class="activeTab == 1 ? 'on' : ''" @click="activeTab = 1">
          Order analysis
        </li>
        <li
          :class="activeTab == 2 ? 'on' : ''"
          style="border-radius:0 "
          @click="activeTab = 2"
        >
          Product analysis
        </li>
      </ul>
      <div>
        <order-analysis v-if="activeTab === 1"></order-analysis>
        <product-analysis v-if="activeTab === 2"></product-analysis>
      </div>
    </div>
    <!-- <page-footer></page-footer> -->
  </div>
</template>
<script>
// import pageFooter from "@/components/backstageManagement/public/menberFooterInfo.vue";
import orderAnalysis from "./orderAnalysis.vue";
import productAnalysis from "./productAnalysis.vue";
export default {
  name: "statement",
  components: { orderAnalysis, productAnalysis },
  data() {
    return {
      activeTab: 1 //主 tab
    };
  }
};
</script>
<style>
.statement .el-tabs__nav-wrap::after {
  height: 0 !important;
}
</style>
<style scoped>
/*-----------头部标题切换样式------------------*/
/* @import "../../../../static/css/userCenterList.css"; */
/* @import "./userCenterList.css";
@import "./userCenterList.css"; */
.activeTabT {
  background: #f9f9f9;
  height: 40px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.activeTabT li {
  float: left;
  font-size: 14px;
  line-height: 40px;
  padding: 0 20px;
  font-weight: bold;
  cursor: pointer;
}
.activeTabT li.on {
  background: #fff;
  border-top-left-radius: 10px;
  color: #0c5ee4;
}
.activeTabT li.on2 {
  background: #fff;
  color: #0c5ee4;
}
.statement {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.12);
}
.statement .activeTabT {
  background: #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/statement/statement.vue